import type { EditableEncounter } from '@getvim-adapter/api';
import { DEFAULT_EDITABLE_STATUS_VALUES } from '@getvim-adapter/api';
import type { DeepRequired } from '@getvim-os/types';

export const editableEncounter: DeepRequired<EditableEncounter> = {
  status: {
    isEditable: false,
    reason: '',
    ...DEFAULT_EDITABLE_STATUS_VALUES,
  },
  identifiers: {
    encounterId: {
      isEditable: false,
      reason: '',
    },
  },
  assessment: {
    diagnosisCodes: {
      isEditable: true,
      reason: '',
    },
    generalNotes: {
      isEditable: true,
      reason: '',
    },
    diagnosisCodesNotes: {
      isEditable: true,
      reason: '',
    },
  },
  basicInformation: {
    encounterDateOfService: {
      isEditable: false,
      reason: '',
    },
    status: {
      isEditable: false,
      reason: '',
    },
  },
  objective: {
    generalNotes: {
      isEditable: true,
      reason: '',
    },
    physicalExamNotes: {
      isEditable: true,
      reason: '',
    },
  },
  patientInstructions: {
    generalNotes: {
      isEditable: true,
      reason: '',
    },
  },
  plans: {
    generalNotes: {
      isEditable: true,
      reason: '',
    },
    procedureCodes: {
      isEditable: true,
      reason: '',
    },
    nextAppointmentFollowUpNotes: {
      isEditable: true,
      reason: '',
    },
  },
  provider: {
    providerId: {
      isEditable: false,
      reason: '',
    },
    providerName: {
      isEditable: false,
      reason: '',
    },
  },
  encounterNotes: {
    generalNotes: {
      isEditable: true,
      reason: '',
    },
  },
  subjective: {
    chiefComplaintNotes: {
      isEditable: true,
      reason: '',
    },
    generalNotes: {
      isEditable: true,
      reason: '',
    },
    historyOfPresentIllnessNotes: {
      isEditable: true,
      reason: '',
    },
    reviewOfSystemsNotes: {
      isEditable: true,
      reason: '',
    },
    medicalHistoryNotes: {
      isEditable: true,
      reason: '',
    },
    surgicalHistoryNotes: {
      isEditable: true,
      reason: '',
    },
    hospitalizationNotes: {
      isEditable: true,
      reason: '',
    },
    familyHistoryNotes: {
      isEditable: true,
      reason: '',
    },
    socialHistoryNotes: {
      isEditable: true,
      reason: '',
    },
  },
};
